import {
  ApiResponse,
  CancelAudioTranscriptionPostRequest,
  InitOverrideFunction,
  TranscriptionApi,
  TranscriptionTranscribeAudioFilePostRequest,
} from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { TranscriptionApiService } from "../ApiServices/TranscriptionApiService";
import GenericService from "../GenericService";

export class TranscriptionService extends GenericService<TranscriptionApi, TranscriptionApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, TranscriptionApi, TranscriptionApiService);
  }

  public async transcribe(
    audio: TranscriptionTranscribeAudioFilePostRequest,
    overrides: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.apiService.transcriptionTranscribeAudioFilePostRaw(audio, overrides);
  }

  public async cancelActiveAudioTranscription(request: CancelAudioTranscriptionPostRequest): Promise<string> {
    return this.apiService.cancelAudioTranscriptionPost(request);
  }
}
